<template>
  <auth-layout>
      <jet-authentication-card>
<!--          <template #logo>-->
<!--              <logo class="text-center" :show-name="true"/>-->
<!--          </template>-->


          <div class="card-header">
              <logo class="text-center" :show-name="true"/>
          </div>

          <div class="card-body px-5 py-4">

              <jet-validation-errors class="mb-3" />

              <div v-if="status" class="alert alert-success mb-3 rounded-0" role="alert">
                  {{ status }}
              </div>

              <form @submit.prevent="submit">
                  <div class="form-group">
                      <jet-label for="email" value="Email" />
                      <jet-input id="email" type="email" v-model="form.email" required autofocus />
                  </div>

                  <div class="form-group">
                      <jet-label for="password" value="Password" />
                      <jet-input id="password" type="password" v-model="form.password" required autocomplete="current-password" />
                  </div>

                  <div class="form-group">
                      <div class="custom-control custom-checkbox">
                          <jet-checkbox id="remember_me" name="remember" v-model:checked="form.remember" />

                          <label class="custom-control-label" for="remember_me">
                              Remember Me
                          </label>
                      </div>
                  </div>

                  <div class="mb-0">
                      <div class="d-flex justify-content-end align-items-baseline">
                          <inertia-link :href="route('password.forgot', {...global_url_params})" class="text-muted mr-3">
                              Forgot your password?
                          </inertia-link>

                          <jet-button class="ml-4" :class="{ 'text-white-50': form.processing }" :disabled="form.processing">
                              Log in
                          </jet-button>
                      </div>
                  </div>
              </form>
          </div>

          <hr class="my-0">

          <div class="card-body px-5 py-4 text-center">
              <a class="social-sign-in"
                 title="Sign in with Google"
                 :href="route('auth.social.google.redirect', {...global_url_params})">
                  <img src="/images/social-logins/btn_google_signin_dark_normal_web@2x.png">
              </a>
          </div>

          <div class="card-footer text-center">
              Don't have an account yet?
              <inertia-link :href="route('register', {...global_url_params})">
                  Register Now.
              </inertia-link>
          </div>

      </jet-authentication-card>
  </auth-layout>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import helpers from "@/mixins/helpers";
import AuthLayout from "@/Layouts/AuthLayout";
import Logo from "@/Components/Common/Logo";
import mixpanel from "mixpanel-browser";
import utils from "@/mixins/utils";

export default {
  components: {
      Logo,
      AuthLayout,
    JetAuthenticationCard,
    JetAuthenticationCardLogo,
    JetButton,
    JetInput,
    JetCheckbox,
    JetLabel,
    JetValidationErrors
  },

  mixins: [helpers, utils],

  props: {
    canResetPassword: Boolean,
    status: String
  },

  data() {
    return {
      form: this.$inertia.form({
        email: '',
        password: '',
        remember: false
      })
    }
  },

  methods: {
    submit() {
      this.form
          .transform(data => ({
            ... data,
            remember: this.form.remember ? 'on' : ''
          }))
          .post(this.route('login', {...this.global_url_params}), {

            onFinish: () => {

                if( this.$page?.props?.user ){
                    const user = this.$page.props.user;
                    this.mixpanel.identify( user.id );
                    this.mixpanel.people.set(this.utils.flatten(user));
                    this.mixpanel.track('LOGIN', {user: this.utils.flatten(user)});
                }

                this.form.reset('password');
            },

          });
    }
  }
}
</script>
<style lang="scss">
.social-sign-in{
    display: inline-block;

    img{
        max-width: 220px;
        height: auto;
    }
}
</style>
